<mat-chip-listbox>
    <mat-chip *ngIf="value?.length === 0"
              topicCardTypeColor
              [itemType]="noTypeItem">
        {{getItemLabel(noTypeItem)}}
    </mat-chip>
    <mat-chip *ngFor="let item of itemsToShow"
              removable
              topicCardTypeColor
              [itemType]="item"
              [record]="record"
              [matTooltip]="getItemLabel(item)"
              (removed)="removeItem(item)">
        {{getItemLabel(item)}}
        <button matChipRemove
                *ngIf="showRemove && !disabled"
                class="st-topic-type-button-remove"
                [attr.aria-label]="'remove ' + item">
            <mat-icon>close</mat-icon>
        </button>
    </mat-chip>
    <mat-chip *ngIf="maxValuesToShow > 0 && value?.length > maxValuesToShow"
              class="st-topic-type-plus-chip"
              [disabled]="disabled">
        {{ maxValuesToShowLabel }}
    </mat-chip>
    <mat-chip class="st-topic-type-add"
              *ngIf="showAdd && !disabled"
              [class.st-topic-type-add-invalid]="required && value?.length == 0"
              [class.st-topic-type-add-required]="required"
              [matMenuTriggerFor]="listDropDownMenu"
              [matTooltip]="label"
              (menuClosed)="valueChanged()">
        <mat-icon matChipAvatar>add</mat-icon>
        {{label}}
    </mat-chip>
</mat-chip-listbox>

<mat-menu #listDropDownMenu="matMenu">
    <mat-selection-list [ngModel]="value"
                        click-stop-propagation
                        (selectionChange)="internalValueChanged($event)">
        <mat-list-option *ngFor="let item of itemList"
                         [dir]="dir"
                         [value]="item.id">
            {{item.title}}
        </mat-list-option>
    </mat-selection-list>
</mat-menu>
